// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import { FilesHelper } from '@shared/utils/FilesHelper';
import ExportScreenTemplate from '@front/templates/ExportScreenTemplate.html';
import { TerceraCheckBox } from '../elements/TerceraCheckBox';
import { PanelLocKeys } from '../UtilsClasses/FactoryConstants';
import { TerceraWindowBase } from './TerceraWindowBase';
import { DateTimeUtils } from '@shared/utils/Time/DateTimeUtils';
import { TerceraButtonStyle } from '@shared/utils/Enums/ButtonEnums';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
let instance = null;
export class ExportScreen extends TerceraWindowBase {
    constructor() {
        super();
        this.chbArray = null;
        this.onCheckAllStateChange = (event) => {
            // Check all CheckBox's logic
            // TODO to think
            if (this.internalChange) {
                return;
            }
            const cbList = this.chbArray;
            void this.set('Checked', event.currentTarget.checked);
            this.internalChange = true;
            for (const checkbox of cbList) {
                checkbox.set('checked', event.currentTarget.checked);
            }
            this.internalChange = false;
        };
        this.chbArray = [];
    }
    getType() {
        return 'ExportScreen';
    }
    oninit() {
        super.oninit();
        this.localize();
    }
    localize() {
        void this.set({
            header: Resources.getResource('screen.export.header'),
            okText: Resources.getResource('screen.export.Export'),
            cancelText: Resources.getResource('screen.export.Cancel')
        });
    }
    oncomplete() {
        super.oncomplete();
        this.on('cancelClick', this.close.bind(this));
        this.on('okClick', this.okClick.bind(this));
        this.on('ExportTypeChanged', this.exportTypeChanged.bind(this));
        const keys = ExportScreen.exportTo;
        const items = [];
        keys.forEach(function (key) {
            if (!Resources.isHidden(key)) {
                items.push({ type: NewContextMenuItemType.Default, text: key, value: key });
            }
        });
        void this.set({ cbItems: items });
        this.center();
    }
    okClick() {
        this.exportToFile();
        this.close();
    }
    exportToFile() {
        const data = this.getDataToExport();
        const filename = this.get('saveFileName');
        switch (this.get('exportType')) {
            case ExportScreen.CSV:
                this.exportToCSVFile(filename, data);
                break;
            case ExportScreen.EXCEL:
                this.exportToExcelFile(filename, data);
                break;
        }
    }
    exportToCSVFile(filename, data) {
        const preparedForCSV = this.prepareForCSVExport(data);
        FilesHelper.saveFile(filename, preparedForCSV);
    }
    exportToExcelFile(filename, data) {
        if (!(data === null || data === void 0 ? void 0 : data.length)) {
            return;
        }
        const table = [
            {
                Data: data,
                TableName: filename
            }
        ];
        void FilesHelper.saveExcelFile(filename, table);
    }
    getDataToExport() {
        // return Array of Arrays
        const qt = this.panel.quickTableRactive.quickTable;
        const rows = qt.rowsArray;
        const cols = qt.sortedColumns;
        const colsID = this.getColsIDToExport();
        const result = [];
        if (colsID.length === 0) {
            return result;
        }
        const headers = [];
        for (let j = 0; j < colsID.length; j++) {
            headers.push(cols[colsID[j]].headerText);
        }
        result.push(headers);
        const fuckingReplaceSymbol = String.fromCharCode(160); // не переносимый пробел нужно заметь на обычный
        const normalSymbol = String.fromCharCode(32); // не переносимый пробел нужно заметь на обычный
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            if (row.visible) {
                const rowToExport = [];
                for (let j = 0; j < colsID.length; j++) {
                    const ind = cols[colsID[j]].PRIVATE.index;
                    const cell = row.cells[ind];
                    rowToExport.push(cell.formattedValue.replaceAll(fuckingReplaceSymbol, normalSymbol));
                }
                result.push(rowToExport);
            }
        }
        return result;
    }
    prepareForCSVExport(arrOfArrays) {
        let result = '';
        if (!arrOfArrays.length) {
            return result;
        }
        for (let i = 0; i < arrOfArrays.length; i++) {
            const row = arrOfArrays[i];
            for (let j = 0; j < row.length; j++) {
                result += row[j] + ';';
            }
            result += '\r\n';
        }
        return result;
    }
    getColsIDToExport() {
        const colsToExport = [];
        const cbList = this.chbArray;
        for (let i = 0; i < cbList.length; i++) {
            const cb = cbList[i];
            if (cb.get('checked')) {
                colsToExport.push(cb.get('tag'));
            }
        }
        return colsToExport;
    }
    populateCheckBoxList(table) {
        const cols = table.sortedColumns;
        const cbListPanel = this.Controls.checkBoxList;
        let cbNum = 0;
        let chCount = 0;
        const f = this.oneCheck.bind(this);
        for (let i = 0; i < cols.length; i++) {
            if (!cols[i].hidden) {
                const colCheckBox = new TerceraCheckBox();
                void colCheckBox.set({
                    top: 3 + cbNum * 24,
                    left: 12,
                    text: cols[i].headerText,
                    checked: cols[i].visible,
                    tag: i
                });
                if (cols[i].visible) {
                    chCount++;
                }
                cbListPanel.addControl(colCheckBox);
                this.chbArray.push(colCheckBox);
                colCheckBox.on('CheckedStateChange', f);
                cbNum++;
            }
        }
        this.setInternalAllChecked(cbNum === chCount);
        const div = this.find('.js-checkboxlist-panel');
        if (div) {
            HtmlScroll.addScroll(div);
        }
    }
    setInternalAllChecked(value) {
        // TODO to think
        this.internalChange = true;
        void this.set('Checked', value).then(function () {
            this.internalChange = false;
        }.bind(this));
    }
    oneCheck(sender) {
        if (this.internalChange) {
            return;
        }
        const cbList = this.chbArray;
        let res = true;
        for (let i = 0; i < cbList.length; i++) {
            res = res && cbList[i].get('checked');
        }
        if (this.get('Checked') !== res) {
            this.setInternalAllChecked(res);
        }
    }
    exportTypeChanged(context, value) {
        void this.set('exportType', value);
        void this.set('saveFileName', this.generateFileName());
    }
    updateControls(panel) {
        this.panel = panel;
        const qtr = panel.quickTableRactive; // Check box list
        if (qtr === null || qtr === void 0 ? void 0 : qtr.quickTable) {
            this.populateCheckBoxList(qtr.quickTable);
        }
        void this.set('saveFileName', this.generateFileName());
    }
    generateFileName() {
        const dateStr = DateTimeUtils.formatDate(new Date(), 'DD.MM.YYYY_HH-mm-ss');
        const fileType = this.get('exportType') === ExportScreen.CSV ? '.csv' : ''; // adding extension for Excel in FilesHelper.saveExcelFile
        const fileName = Resources.getResource(PanelLocKeys[this.panel.getType()]) + '_' + dateStr + fileType;
        return fileName;
    }
    static show(panel) {
        if (instance) {
            instance.close();
        }
        instance = new ExportScreen();
        instance.on('teardown', function () {
            instance = null;
        });
        MainWindowManager.AddControl(instance);
        instance.updateControls(panel);
        instance.setFocus();
    }
}
ExportScreen.CSV = 'screen.export.CSV';
ExportScreen.EXCEL = 'screen.export.Excel';
ExportScreen.exportTo = [ExportScreen.CSV, ExportScreen.EXCEL];
TerceraWindowBase.extendWith(ExportScreen, {
    data: function () {
        return {
            movable: true,
            resizable: false,
            showFooter: false,
            focused: true,
            Checked: false,
            width: 300,
            cbItems: [],
            btnOKStyle: TerceraButtonStyle.Blue,
            btnCancelStyle: TerceraButtonStyle.Standard,
            exportType: ExportScreen.CSV,
            saveFileName: '',
            cbFormatTooltip: 'screen.export.selectFormat.tt',
            checkAllText: Resources.getResource('screen.export.checkAllText')
        };
    },
    partials: { bodyPartial: ExportScreenTemplate }
});
